import * as React from 'react';
import { Row, Col } from 'antd';
import SyncDb from './SyncDb';

export default class extends React.Component {
  render() {
    return (
      <div>
        <Row>
          <Col span={12}>
            <SyncDb />
          </Col>
          <Col span={12}>
            <div />
          </Col>
        </Row>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/tools/index.tsx